import { HTTP } from './http-common'

export default {
  getAccounts() {
    return HTTP.get('/account')
  },
  async getClaimForUser(user) {
    return await HTTP.get(`/account/${user.email}/claims`)
  },
  getRolesForUser(user) {
    return HTTP.get(`/account/${user.email}/roles`)
  },
  insertRoles(user, role) {
    return HTTP.post(`/account/${user.email}/roles?role=${role}`)
  },
  removeRoles(user, role) {
    return HTTP.delete(`/account/${user.email}/roles/${role}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/adminService.js